<template>
  <div id="about_nav">
    <div class="nav-content">
      <div class="volunteer-box">
        <h3>如何成为志愿者</h3>
        <p>湖南爱眼公益基金会是一家专注于眼健康领域的公益基金会，自成立起倡导志愿者活动，引入社会调查和服务机制，2019年通过系统管理，招募志愿者开展调查，以“微记录”的方式发现眼健康诉求，动员社会开展救助，并创造和提供了更完善的救助渠道。</p>
        <p>2015年至今，救助行动覆盖了全国30个省、直辖市，138个地区以及东南亚一带一路沿线国家和非洲地区，直接服务1.2亿人次，救助患者66万人次，救助项目资金规模达4亿元，扎实推进了一批具有全国影响力的公益项目，如“精准脱贫光明行”、 “一带一路光明行”、 “澜湄合作-光明行”、“健康视界尽收眼底”、“青少年视力健康行动”、“点亮心灯”等项目。同时，2016年以来，基金会借助日渐兴起的互联网公益平台，联合各大公募组织发起了众筹项目10个，获得广大网友和新闻媒体的广泛关注和高度认可，共募集资金31256.14万元。 其中“你是我的眼”角膜盲症救助行动在全国范围内进行了巡诊和公益教学活动，共救助了300多名患者，使他们重见光明，该项目社会反响巨大，被评为了第十六届（2019）中国慈善榜“十大慈善项目”。</p>
        <p>在运营模式上，基金会一直积极探索并拓展眼健康领域的公益模式，即可覆盖全生命周期的专业+公益的可持续发展模式。2019年在24届中华眼科年会上成立专家志愿团，并启动“互联网公益助力国民眼健康事业项目”，打响全民眼健康保卫战，助力健康中国的实现。</p>
        <p>未来将建立长效的运行机制，扩大志愿者服务体系，加强统筹协调，通过专业力量的系统性参与，大力提升公益项目的效率，使每一份善款都发挥最大效用。</p>
      </div>
      <div class="btn-box">
        <router-link to="/volunteerApply">
          <button v-if="ifvounteer">明白了，立即成为志愿者</button>
          <button v-else>查看详情</button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      ifvounteer: true
    };
  },
  methods: {},
  created() {
    let loginInfo = sessionStorage.getItem("token");

    if (loginInfo && loginInfo != "null") {
      this.$db.post(this.$db.config.getVolAndBranchInfo, {}).then(res => {
        if (res.code == 200 && res.data.volunteer_id) {
          this.ifvounteer = false;
          this.$confirm(
            "检测您已经成为志愿者是否跳转志愿者页面？",
            "确认信息",
            {
              distinguishCancelAndClose: true,
              confirmButtonText: "确认",
              cancelButtonText: "取消"
            }
          )
            .then(() => {
              this.$router.push({ name: "volunteerApply" });
            })
            .catch(action => {
              // this.$router.push({path:'/'})
              // sessionStorage.removeItem('bread1');
              // sessionStorage.removeItem('index')
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#about_nav {
  width: 100%;
}
.nav-content {
  width: 1300px;
  margin: 0 auto;
  .volunteer-box {
    padding-top: 56px;
    > h3 {
      font-size: 30px;
      color: #333333;
      margin-bottom: 30px;
    }
    > p {
      text-indent: 2em;
      font-size: 16px;
      color: #666666;
      line-height: 30px;
      margin-bottom: 15px;
    }
  }
  .btn-box {
    margin-top: 75px;
    text-align: center;
    margin-bottom: 270px;
    > a {
      > button {
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
        font-size: 21px;
        color: #ffffff;
        width: 261px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        background-color: #c30d23;
        box-shadow: 2px 3px 10px 0px rgba(9, 1, 4, 0.21);
        border-radius: 6px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Volunteer/volunteer_index.vue